import React from 'react'

import classnames from 'classnames'

import './MessageFeedback.scss'

const MessageFeedback = ({ children, className, kind }) => {
  const compClassName = classnames('msg-feedback', className, {
    [`msg-feedback__${kind}`]: kind
  })

  return (
    <div className={compClassName}>{children}</div>
  )
}

export default MessageFeedback
